<template>
  <div>
    <div class="flex items-center justify-between rmb50">

      <h3 class="flex items-center text-base font-semibold rmb0 rmr50">
        <span class="rmr50">Selected:</span>
        <span class="rmr50 text-xs font-normal">({{selected.length}})</span>
        <span v-if="selected.length" class="cursor-pointer" :class="{open: open}" @click="open = !open"><i class="fas fa-angle-right"></i></span>
      </h3>

      <div class="flex items-center flex-grow justify-end">
        <button v-if="open && selected.length" class="btn btn-danger btn-xs rmr50" @click="removeAllSelectedProjects">Remove All</button>
        <button class="btn btn-xs" :class="selected.length ? 'btn-carma' : 'disabled text-white'" :disabled="!selected.length" @click="enableAllProjects">Enable All</button>
      </div>

    </div>

    <div class="rmt75 base-background-color shadow rounded-md" v-if="open">

      <ul>
        <li
          v-for="(project, index) in selected"
          :key="`selected-${index}`"
          class="flex items-center justify-between rpl50 text-xs border-b-gray border-last-none"
        >
          <span>{{ project.project_name }}</span>

          <!-- Icons: Enable / Remove -->
          <div class="flex items-center">
            <button class="btn btn-carma btn-xs" @click="enableProject(project)">Enable</button>
            <div @click="removeSelectedProject(project)" class="rp75 text-xs leading-xs text-gray-500 hover:text-red-900 cursor-pointer" >
              <i class="fas fa-times"></i>
            </div>
          </div>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: Array
  },
  data() {
    return {
      open: false
    }
  },
  methods: {
    enableProject(project) {
      this.$emit('enableProject', project)
    }, 
    
    enableAllProjects() {
      this.$emit('enableAllProjects')
    },

    removeSelectedProject(project) {
      this.$emit('removeSelectedProject', project)
    },

    removeAllSelectedProjects() {
      this.$emit('removeAllSelectedProjects', true)
    }
  },
};
</script>

<style lang="scss" scoped>

.text-white {
  color: #fff;
}

.rounded-md	{
  border-radius: 0.375rem;
}

.leading-xs {
  line-height: 0.75rem;
}

.border-b-gray {
  border-bottom: 1px solid #ddd;
}

.border-last-none:last-of-type {
  border: none;
}

.btn-xs {
  padding: 4px;
  width: auto;
  height: auto;
  line-height: 1;
  font-size: 0.875em;
  margin-bottom: 0;
}

.text-gray-500 {
  color: #9b9b9b;
}

.base-background-color {
  --bg-opacity: 1;
  background-color: #f8f8f8;
  background-color: rgba(rgb(248, 248, 248), var(--bg-opacity));
}

.even\:base-background-color:nth-child(even) {
  --bg-opacity: 1;
  background-color: #f8f8f8;
  background-color: rgba(rgb(248, 248, 248), var(--bg-opacity));
}

.hover\:text-orange:hover {
  --text-opacity: 1;
  color: #ec9148;
  color: rgba(236, 145, 72, var(--text-opacity));
}

.hover\:text-red-900:hover {
  --text-opacity: 1;
  color: #742a2a;
  color: rgba(116, 42, 42, var(--text-opacity));
}

.open {
  transform: rotate(90deg);
}

</style>
